import { useTranslation } from 'react-i18next';
import { Box, Flex, Text, Button, useColorModeValue } from "@chakra-ui/react";
import { useNavigate } from 'react-router-dom';

export default function Unauthorized() {
  const { t } = useTranslation();

    const navigate = useNavigate();

    return (
        <Flex
            minH="100vh"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            textAlign="center"
            bg={useColorModeValue("#f8f9fb", "gray.900")}
            px={4}
        >
            <Box className="animate-fade-up">
                <Text
                    fontSize={{ base: "80px", md: "120px" }}
                    fontWeight="900"
                    letterSpacing="-0.04em"
                    lineHeight="1"
                    className="gradient-text-purple"
                    mb={2}
                >
                    401
                </Text>
                <Text
                    fontSize={{ base: "xl", md: "2xl" }}
                    fontWeight="700"
                    color={useColorModeValue("gray.700", "gray.200")}
                    mb={3}
                    letterSpacing="-0.02em"
                >
                    {t("Accès non autorisé")}
                </Text>
                <Text
                    fontSize="15px"
                    color={useColorModeValue("gray.500", "gray.400")}
                    mb={8}
                    maxW="400px"
                    mx="auto"
                    lineHeight="1.6"
                >
                    {t("Vous n'êtes pas autorisé à accéder à cette page.")}
                </Text>
                <Button
                    colorScheme='purple'
                    onClick={() => navigate(-3)}
                    h="44px"
                    px={8}
                    fontSize="14px"
                    fontWeight="600"
                    borderRadius="12px"
                    bg="linear-gradient(135deg, #7B5EA7 0%, #9F7AEA 100%)"
                    _hover={{
                        bg: "linear-gradient(135deg, #6B4E97 0%, #8F6ADA 100%)",
                        transform: "translateY(-1px)",
                        boxShadow: "0 8px 25px -5px rgba(128, 90, 213, 0.4)"
                    }}
                    _active={{ transform: "scale(0.98)" }}
                    transition="all 0.2s ease"
                >
                    {t("Retourner")}
                </Button>
            </Box>
        </Flex>
    )
}